module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_redefine.js
// module id = 480
// module chunks = 0 1